<template>
  <base-card
    v-if="EntityCardMixin_CopySource"
    :title="EntityCardMixin_Title"
  >
    <v-row>
      <template
        v-if="EntityCardMixin_Picker"
      >
        <base-picker
          v-if="entityCardMixin.pickers.components[0]"
          v-model="entityCardMixin.pickers.components[0]"
          base-field-container-type="v-col"
          :items="children"
          :label="TextMixin_GetLabel('child')"
          :rules="pickers[0].rules"
          @pickers-create="$emit('pickers-create', $event)"
          @pickers-read="$emit('pickers-read', $event)"
          @pickers-update="$emit('pickers-update', $event)"
        />
      </template>
      <base-field
        v-if="EntityCardMixin_CopySource.budgetTotalAmount"
        v-model="EntityCardMixin_CopySource.budgetTotalAmount"
        base-field-container-type="v-col"
        base-field-type="number"
        :decimals="2"
        :disabled="EntityCardMixin_Disabled"
        :label="TextMixin_GetLabel('budget', `(${TextMixin_GetParameter('requested').toLowerCase()})`)"
        prefix="€"
        :readonly="EntityCardMixin_Readonly"
        :rules="[validationMixin.rules.numberGreaterThan(EntityCardMixin_CopySource.budgetTotalAmount.value, 0, true)]"
      />
      <base-field
        v-if="EntityCardMixin_CopySource.budgetReason"
        v-model="EntityCardMixin_CopySource.budgetReason"
        base-field-container-type="v-col"
        base-field-type="autocomplete"
        code
        :disabled="EntityCardMixin_Disabled"
        :items="contentMixin.codes"
        :label="TextMixin_GetLabel('reason')"
        :readonly="EntityCardMixin_Readonly"
      />
      <base-field
        v-if="EntityCardMixin_CopySource.budgetReasonOther && IsOtherReason()"
        v-model="EntityCardMixin_CopySource.budgetReasonOther"
        autogrow
        base-field-container-type="v-col"
        base-field-type="textarea"
        :disabled="EntityCardMixin_Disabled"
        :label="TextMixin_GetLabel('explanation')"
        :readonly="EntityCardMixin_Readonly"
        rows="1"
        :rules="[validationMixin.rules.required]"
      />
    </v-row>
  </base-card>
</template>

<script>
import EntityCardMixin from '@/mixins/entity-card-mixin'

export default {
  name: 'EntityCardRequestsDetailSubmitRequestExtraBudgetDetails',
  mixins: [
    EntityCardMixin
  ],
  mounted () {
    this.Initialize()
  },
  methods: {
    Initialize () {
      this.EntityCardMixin_SetDefaultTitle('details')
    },
    IsOtherReason () {
      return this.EntityCardMixin_CopySource.budgetReason.value && this.EntityCardMixin_CopySource.budgetReason.value.toUpperCase() === this.constantMixin.codes.requestExtraBudgetReason.values.other
    }
  }
}
</script>
